import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { LanguageString } from "../../../Model/LanguageString";
import { PopupHasMeasuresComponent } from "../Popups/PopupHasMeasuresComponent";
import { WidgetHasMeasuresComponent } from "../Components/WidgetHasMeasuresComponent";

export class WidgetHasMeasuresProps {
    public title: LanguageString;
    public textAny?: string;
    public textNone?: string;
    public templateIds: number[];

    public iconCssClass?: string;

    public additionalFilter?: string;

    public rowClickUrl?: string;
    public rowClickUrlUsePopup?: boolean;
}

export class WidgetHasMeasures extends WidgetBase {
    props: WidgetHasMeasuresProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetHasMeasuresProps();
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (!this.props.templateIds) {
                this.props.templateIds = [];
            }

            if (this.props.title == null)
                this.props.title = new LanguageString();
        }
        else
            this.props.title = new LanguageString();
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    getType(): WidgetTypes {
        return WidgetTypes.HasMeasures;
    }

    showPopup(): void {
        let popup = new PopupHasMeasuresComponent({ widget: this });
        document.body.appendChild(popup.render());
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number, paramter?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetHasMeasuresComponent({
            widget: this
        });
        return this.component.render();
    }

}